export default __webpack_public_path__ + "static/media/2570.7228c7b3.png";